export default __webpack_public_path__ + "static/media/InstallationPrices.819de10f.svg";